// event-registration-form-app/components/AttendeeFields.jsx

import React from "react";
import _ from "lodash";
import FormField from "./FormField";

const AttendeeFields = ({ form, attendeeFields, index, onUpdateValue, onRemoveAttendee, handleToggleAttendee, attendeeActive, alreadySubmitted }) => {
  const groupedSelectedOptions = attendeeFields
    .filter((field) => field.type === "PurchasableItems")
    .map((field) => ({
      fieldName: field.label || field.name,
      selectedOptions: field.purchasableOptions
        .filter((option) => {
          const selectionPath = `attendees[${index}].${field.id}`;
          const selections = _.get(form.values, selectionPath, []);
          return selections.includes(option.id);
        })
        .map((option) => ({
          name: option.name,
          cost: option.cost,
        })),
    }))
    .filter((group) => group.selectedOptions.length > 0); // Filter out fields with no selected options

  // Then, calculate the total cost
  const totalCost = groupedSelectedOptions.flatMap((group) => group.selectedOptions).reduce((total, option) => total + option.cost, 0);

  return (
    <div className="c-event-registration-form__attendee-wrapper">
      <div
        className={`c-event-registration-form__attendee-toggle ${attendeeActive ? "c-event-registration-form__attendee-toggle--active" : ""}`}
        onClick={() => !alreadySubmitted && handleToggleAttendee()}
      >
        <h4>
          Attendee {index + 1}
          {form.values.attendees &&
            form.values.attendees[index] &&
            (form.values.attendees[index].gFirstName || form.values.attendees[index].gLastName) &&
            ` - ${form.values.attendees[index].gFirstName}  ${form.values.attendees[index].gLastName}`}
        </h4>
        {!alreadySubmitted && (
          <div className={`c-event-registration-form__attendee-toggle-indicator ${attendeeActive ? "c-event-registration-form__attendee-toggle-indicator--active" : ""}`}></div>
        )}
      </div>

      <div
        className={`c-event-registration-form__attendee-fields ${
          !alreadySubmitted && (attendeeActive ? "c-event-registration-form__attendee-fields--slide-down" : "c-event-registration-form__attendee-fields--slide-up")
        }`}
      >
        {attendeeFields.map((field) => (
          <FormField
            key={`${field.id}-${index}`}
            form={form}
            field={{ ...field, id: `attendees[${index}].${field.id}`, niceName: field.label, attendeeIndex: index }}
            onUpdateValue={onUpdateValue}
            readOnly={alreadySubmitted}
          />
        ))}
        {/* Display selected PurchasableItems and their costs */}

        <table className="c-event-registration-form__subtotal-table">
          <thead>
            <tr>
              <th colSpan="2">
                <h5 style={{ marginBottom: 0 }}>Selected Options</h5>
              </th>
            </tr>
          </thead>
          {groupedSelectedOptions.length > 0 ? (
            groupedSelectedOptions.map((group, groupIndex) => (
              <React.Fragment key={groupIndex}>
                <tbody className="c-event-registration-form__table-header-row">
                  <tr>
                    <td colSpan="2">{group.fieldName}</td>
                  </tr>
                </tbody>
                <tbody>
                  {group.selectedOptions.map((option, optionIndex) => (
                    <tr key={optionIndex}>
                      <td>{option.name}</td>
                      <td className="c-event-registration-form__table-cell-cost">${option.cost}</td>
                    </tr>
                  ))}
                </tbody>
              </React.Fragment>
            ))
          ) : (
            <tbody>
              <tr>
                <td colSpan="2">No selected options</td>
              </tr>
            </tbody>
          )}

          <tfoot>
            <tr>
              <td>
                <strong>Total</strong>
              </td>
              <td className="c-event-registration-form__table-cell-cost">${totalCost}</td>
            </tr>
          </tfoot>
        </table>

        {!alreadySubmitted && (
          <div className="c-event-registration-form__actions">
            <button type="button" className="c-event-registration-form__button c-event-registration-form__button-remove" onClick={onRemoveAttendee}>
              Remove Attendee
            </button>
          </div>
        )}
        {/* <pre className="c-event-registration-form__debug-wrapper">{JSON.stringify(attendee, null, 2)}</pre> */}
      </div>
    </div>
  );
};

export default AttendeeFields;
